/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {deleteSendSafelyPackage} from '../api'

export const useMutationDeleteSendSafelyPackage = createReactQueryMutationHook('deleteSendSafelyPackage', deleteSendSafelyPackage)
